import {Api} from '../../Api.js'

const RESOURCE = 'pass'

export default {
    resource: RESOURCE,
    prefix: 'pass/',
    query(query) {
        return Api().get(this.prefix + this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.prefix + this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.prefix + this.resource, data)
    },
    update(id, data) {
        return Api().put(this.prefix + this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.prefix + this.resource + '/' + id)
    },
    sync(query) {
        return Api().get(this.prefix + 'sync')
    },
    clean(query) {
        return Api().get(this.prefix + 'clean')
    },
}


// WEBPACK FOOTER //
// ./src/modules/pass/PassService.js